import React, { useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Struck from "../../assets/images/struck.png";
import Historyicon from "../../assets/images/history.png";
import Recovery from "../../assets/images/recovery.png";
import Flight_sdl from "../../assets/images/flight_sdl.png";
import Invoice from "../../assets/images/invoice.png";
import inbox_icon from "../../assets/images/recovery_inbox/inbox-icon.svg";
import Inbound from "../../assets/images/inbound.png";
import Planings from "../../assets/images/planings.png";
import Emports from "../../assets/images/Exports.png";
import Imports from "../../assets/images/imports.png";
import Srecord from "../../assets/images/srecord.png";

import {
  faBoxArchive
} from '@fortawesome/free-solid-svg-icons';

const TopMenu = ({ module, onTab, selectedTab }) => {
  const location = useLocation();
  const history = useHistory();

  const user = localStorage.getItem('Trucking');

  let navItems = [];
  if (module === 'RFS') {
    if (user) {
      navItems = [
        { name: 'Dashboard', path: '/RFSDashboard', image: Struck, },
        { name: 'RFS Monitor', path: '/TruckMonitor', image: Struck, },
        // { name: 'Quote Request', path: '/QuoteRequest', image: Struck, },
      ];
    } else {
      navItems = [
        { name: 'Dashboard', path: '/RFSDashboard', image: Struck, },
        { name: 'Bookingtruck Schedule', path: '/BookingtruckSchedule', image: Struck, },
        { name: 'Truck Order', path: '/TruckOrder', image: Struck, },
        { name: 'AWB Manager', path: '/AWBManager', image: Struck, },
        { name: 'RFS Monitor', path: '/TruckMonitor', image: Struck, },

        // Add more items with respective paths as needed
      ];
    }

  } else if (module === 'Trucking') {
    navItems = [
      { name: 'Dashboard', path: '/Dashboard', image: Struck, tab: 'dash' },
      // { name: 'Bookingtruck Schedule', path: '/BookingtruckSchedule', image: Struck, },
      // { name: 'Truck Order', path: '/TruckOrder', image: Struck, },
      // { name: 'AWB Manager', path: '/AWBManager', image: Struck, },
      { name: 'RFS Monitor', path: '/TruckMonitor', image: Struck, tab: 'mon' },
    ];
  } else if (module === 'HANDLER') {
    navItems = [
      { name: 'RFS Monitor', path: '/HandlerTruckMonitor', image: Struck, },
      { name: 'RFS Dashboard', path: '/HandlerDashboard', image: Struck, },

      // Add more items with respective paths as needed
    ];
  } else if (module === 'HULD') {
    navItems = [
      { name: 'Dashboard', path: '', icon: faBoxArchive, image: Struck, tab: 'das' },
      { name: 'ULD Control', icon: faBoxArchive, image: Struck, tab: 'uld' }, // path: '/ULDControl',
      { name: 'UCM', icon: faBoxArchive, image: Historyicon, tab: 'ucm' }, // path: '/UCM',
      { name: 'SCM', icon: faBoxArchive, image: Recovery, tab: 'scm' }, // path: '/SCM',
      { name: 'LUC', icon: faBoxArchive, image: Invoice, tab: 'luc' }, // path: '/LUC',
      // { name: 'History', path: '/History', icon: faBoxArchive, image: Flight_sdl, },

      // Add more items with respective paths as needed
    ];
  } else if (module === 'ULD') {
    navItems = [
      { name: 'ULD Control', path: '/ULDControl', icon: faBoxArchive, image: Struck, },
      { name: 'History', path: '/History', icon: faBoxArchive, image: Historyicon, },
      { name: 'Recovery', path: '/Recovery', icon: faBoxArchive, image: Recovery, },
      { name: 'Invoice', path: '/Invoice', icon: faBoxArchive, image: Invoice, },
      { name: 'Flight Schedule', path: '/FlightSchedule', icon: faBoxArchive, image: Flight_sdl, },

      // Add more items with respective paths as needed
    ];
  } else if (module === 'FORWARDER') {
    navItems = [
      { name: 'Planned Trips', path: '#', onClick: () => FNavigate('uld', '/ULDForwarder/ActiveTrips', 'activetrips'), fname: '/ULDForwarder/ActiveTrips', icon: faBoxArchive, image: Struck, tab: 'activetrips' },
      { name: 'Planning', path: '#', onClick: () => FNavigate('uld', '/ULDForwarder/Planning', 'planning'), fname: '/ULDForwarder/Planning', icon: faBoxArchive, image: Historyicon, tab: 'planning' },
      { name: 'ULD Stock', path: '#', onClick: () => FNavigate('uld', '/ULDForwarder/ULDStock', 'uldstock'), fname: '/ULDForwarder/ULDStock', icon: faBoxArchive, image: Recovery, tab: 'uldstock' },
      { name: 'Build Up', path: '#', onClick: () => FNavigate('uld', '/ULDForwarder/BuildUp', 'buildup'), fname: '/ULDForwarder/BuildUp', icon: faBoxArchive, image: Recovery, tab: 'buildup' },

      // Add more items with respective paths as needed
    ];
  } else if (module === 'FSHPMNGR') {
    navItems = [
      { name: 'Inbound', path: '/ForwarderShipments/Inbound', icon: faBoxArchive, image: Inbound, }, // /ForwarderShipments/Inbound  // not live
      { name: 'Planning', path: '/ForwarderShipments/Planning', icon: faBoxArchive, image: Planings, }, // /ForwarderShipments/Planning // not live
      { name: 'Export', path: '/ForwarderShipments/Export', icon: faBoxArchive, image: Emports, },
      { name: 'Import', path: '/ForwarderShipments/Import', icon: faBoxArchive, image: Imports, }, // /ForwarderShipments/Import
      { name: 'Shipment Records', path: '/ForwarderShipments/ShipmentRecords', icon: faBoxArchive, image: Srecord, },
      // { name: 'Quotation', path: '/ForwarderShipments/Quotation', icon: faBoxArchive, image: Srecord, },
      { name: 'Invoice', path: '/ForwarderShipments/Invoice', icon: faBoxArchive, image: Srecord, },
      { name: 'Message Log', path: '/ForwarderShipments/Log', icon: faBoxArchive, image: Srecord, },

      // Add more items with respective paths as needed
    ];
  } else if (module === 'DVR') {
    navItems = [
      // { name: 'Driver', path: '/DVRegistration/Driver', icon: faBoxArchive, image: Inbound, }, // /ForwarderShipments/Inbound  // not live
      // { name: 'Visitor', path: '/DVRegistration/Visitor', icon: faBoxArchive, image: Planings, }, // /ForwarderShipments/Planning // not live

      { name: 'Driver', path: '#', icon: faBoxArchive, image: Inbound, tab: 'driver' },
      { name: 'Visitor', path: '#', icon: faBoxArchive, image: Planings, tab: 'visitor' },


      // Add more items with respective paths as needed
    ];
  } else if (module === 'QUT') {
    navItems = [
      { name: 'Air Freight', path: '#', icon: faBoxArchive, image: Inbound, tab: 'arf' }, // /ForwarderShipments/Inbound  // not live
      { name: 'Sea Freight', path: '#', icon: faBoxArchive, image: Planings, tab: 'sef' }, // /ForwarderShipments/Planning // not live
      { name: 'Inbox', path: '#', icon: faBoxArchive, image: inbox_icon, tab: 'ibx' }, // /ForwarderShipments/Planning // not live

      // Add more items with respective paths as needed
    ];
  } else if (module === 'SPL') {
    navItems = [
      { name: 'Planning Dashboard', path: '/PlanningDashboard', icon: faBoxArchive, image: Struck, }, // /ForwarderShipments/Inbound
      { name: 'All Trips', path: '/AllTrips', icon: faBoxArchive, image: Struck, }, // /ForwarderShipments/Planning
      { name: 'Import', path: '#', icon: faBoxArchive, image: Struck, },
      { name: 'Export', path: '#', icon: faBoxArchive, image: Struck, }, // /ForwarderShipments/Import
      // {
      //   name: 'RFS Loading', path: '#', icon: faBoxArchive, image: Struck,
      //   children: [
      //     { name: 'RFS Dashboard', path: '#', image: Struck, onClick: () => navigate('L', '/HandlerDashboard') }, // onClick: () => navigate('D')
      //     { name: 'RFS Monitor', path: '#', image: Struck, onClick: () => navigate('L', '/HandlerTruckMonitor') }, // onClick: () => navigate('M')
      //   ],
      // }, // /ForwarderShipments/Import
      {
        name: 'RFS Control', path: '#', icon: faBoxArchive, image: Struck,
        children: [
          { name: 'RFS Dashboard', path: '#', image: Struck, onClick: () => navigate('L', '/HandlerDashboard') }, // onClick: () => navigate('D')
          { name: 'RFS Monitor', path: '#', image: Struck, onClick: () => navigate('L', '/HandlerTruckMonitor') }, // onClick: () => navigate('M')
        ],
      }, // /ForwarderShipments/Import
      // {
      //   name: 'RFS Unloading', path: '#', icon: faBoxArchive, image: Struck,
      //   children: [
      //     { name: 'RFS Dashboard', path: '#', image: Struck, onClick: () => navigate('U', '/HandlerDashboard') }, // 
      //     { name: 'RFS Monitor', path: '#', image: Struck, onClick: () => navigate('U', '/HandlerTruckMonitor') }, // onClick: () => navigate('M')
      //   ],
      // }, // /ForwarderShipments/Import

      // Add more items with respective paths as needed
    ];
  } else if (module === 'BRK') {
    navItems = [
      { name: 'Bookingtruck Schedule', path: '#', image: Struck, },
      { name: 'Truck Order', path: '#', image: Struck, },
      { name: 'AWB Manager', path: '#', image: Struck, },
      { name: 'RFS Monitor', path: '#', image: Struck, },
      { name: 'Quote Request', path: '/QuoteRequest', image: Struck, },

      // Add more items with respective paths as needed
    ];
  }


  const navItemsCharts = [
    { name: 'Cargo \nDamage', path: '/CargoDamage', icon: faBoxArchive },
    { name: 'ULD \nDamage', path: '/UldDamage', icon: faBoxArchive },
    { name: 'Cargo \nClaim', path: '/CargoClaim', icon: faBoxArchive },
    { name: 'Service \nRecovery', path: '/ServiceRecovery', icon: faBoxArchive },
    { name: 'Email \nSettings', path: '/EmailSettings', icon: faBoxArchive },


    // Add more items with respective paths as needed
  ];
  // console.log("🚀 ~ TopMenu ~ location.pathname:", location.pathname);

  const navigate = (pos, url) => {
    // const tokenValue = localStorage.getItem('SPL');
    // localStorage.setItem('RFS', tokenValue);
    // localStorage.removeItem('SPL');
    if (pos === 'L') {
      // window.location.href = '/HandlerDashboard';
      localStorage.setItem('spl_lu', 'Loading')
    } else if (pos === 'U') {
      // window.location.href = '/HandlerTruckMonitor';
      localStorage.setItem('spl_lu', 'Unloading')
    }
    window.location.href = url;
  };
  const FNavigate = (pos, url, path) => {

    if (pos === 'uld') {
      localStorage.removeItem('grid_tab');
      onTab(path)
    } else if (pos === 'dvf') {
      localStorage.removeItem('grid_tab');
      onTab(path)
    } else {
    }
    window.location.href = url;
  };

  const handleParentClick = (path) => {
    // console.log('path', path);

    window.location.href = path;
  };

  const linksTab = (e, path) => {
    e.preventDefault();
    if (module === 'HULD') {
      localStorage.removeItem('HULDtab');
    } else if (module === 'QUT') {
      localStorage.removeItem('MainTab');
    } else if (module === 'FORWARDER') {
      localStorage.removeItem('MainTab');
    } else if (module === 'DVR') {
      localStorage.removeItem('MainTab');
    }
    onTab(path)

  }
  // console.log(selectedTab);

  const renderTopNavItems = () => {
    return navItems.map((item) => {
      let isActive;
      if (item.tab) {
        isActive = selectedTab === item.tab;
      } else {
        isActive = location.pathname === item.path || (item.children && item.children.some(child => location.pathname === child.path)) || (location.pathname === item.fname);
      }
      // const isTab = selectedTab === item.tab;

      if (item.children && item.children.length > 0) {
        return (
          <li key={item.name} className={`nav-item dropdown ${isActive ? 'active' : ''}`}>
            <a href="#" className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <span><img src={item.image} /></span>
              <span>{item.name}</span>
            </a>
            <ul className="dropdown-menu">
              {item.children.map((child) => (
                <li key={child.name}>
                  <Link to={child.path} onClick={child.onClick} className={`dropdown-item ${location.pathname === child.path ? 'active' : ''}`}>
                    {child.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        );
      } else {
        return (
          <li key={item.name} className="nav-item">
            <Link
              to={item.path}
              onClick={(e) => {
                e.preventDefault();
                // if (module === 'FORWARDER') {
                //   item.onClick()
                // } else 
                if (['HULD', 'QUT', 'FORWARDER', 'DVR', 'Trucking'].includes(module)) {
                  linksTab(e, item.tab)
                } else {
                  handleParentClick(item.path);
                }
              }}
              className={`nav-link ${isActive ? 'active' : ''}`}
            >
              <span><img src={item.image} /></span>
              <span>{item.name}</span>
            </Link>
          </li>
        );
      }
    });
  };

  // const renderTopNavItems = () => {
  //   // if (location.pathname === '/BookingtruckSchedule') {
  //   return navItems.map((item) => (
  //     <li key={item.name} className="nav-item">
  //       {/* {console.log("🚀 ~ TopMenu ~ item.path:", item.path)} */}
  //       <Link
  //         to={item.path}
  //         className={`nav-link ${location.pathname === item.path ? 'active' : ''} nav-link`}
  //       >
  //         <span>
  //           <img src={item.image} />
  //         </span>
  //         <span>
  //           {item.name}
  //           {/* {item.name.split('\n').map((text, i) => (
  //                 <span key={i}>
  //                   {text}
  //                    {i !== item.name.split('\n').length - 1 && <br />} 
  //                 </span>
  //               ))} */}
  //         </span>
  //       </Link>
  //     </li>
  //   ));
  //   // } else if (location.pathname === '/kpicharts') {
  //   return navItemsCharts.map((item) => (
  //     <li key={item.name} className="nav-item">
  //       <Link
  //         to={item.path}
  //         className={`nav-link ${location.pathname === item.path ? 'active' : ''} nav-link`}
  //       >
  //         <span>
  //           <FontAwesomeIcon icon={item.icon} />
  //         </span>
  //         <span>
  //           {item.name.split('\n').map((text, i) => (
  //             <span key={i}>
  //               {text}
  //               {i !== item.name.split('\n').length - 1 && <br />}
  //             </span>
  //           ))}
  //         </span>
  //       </Link>
  //     </li>
  //   ));
  //   // }
  //   // Add more conditions for different left menu pages if needed

  //   // Default return if the current route doesn't match any conditions
  //   return null;
  // };

  return (
    <>
      <ul className={`mb-3 nav nav-tabs top-nav ${module === 'SPL' ? 'slot_plan_hd' : ''}`}>
        {renderTopNavItems()}
        {/* {navItems.map((item) => (
        <li key={item.name} className="nav-item">
            <Link to={item.path} className={`nav-link ${location.pathname === item.path ? 'active' : ''} nav-link`}>
            
            <span><FontAwesomeIcon icon={item.icon} /></span>
            <span>
            
            {item.name.split('\n').map((text, i) => (
            <span key={i}>
                {text}{i !== item.name.split('\n').length - 1 && <br />}
                </span>
                ))}
                </span>
            
            </Link>
        </li>
    ))} */}
      </ul>
    </>
  )
}

export default TopMenu;